import app from 'apprun';
import { __ } from '../Txlat';
export default function ({ chartData_type, chartData_status, chartData_city }) {
  return (
    <div class={(chartData_type && chartData_status && chartData_city && (chartData_type.length > 0 || chartData_status.length > 0 || chartData_city.length > 0)) ? 'agent-stats-wrap d-block' : 'agent-stats-wrap d-none'} >
      <div class="row">
        <div class="col-lg-4 col-md-12 col-sm-12">
          <div class="agent-profile-chart-wrap">
            <h2><span>{__('Property')}</span> {__('Types')}</h2>
            <div class="d-flex align-items-top">
              <div class="agent-profile-chart">
                <canvas id="agent-stats-property-types" data-chart="[28.57142857142857,71.42857142857143]"
                  width="89" height="89" style="display: block; height: 100px; width: 100px;"></canvas>

              </div>
              <div class="agent-profile-data">
                <ul class="list-unstyled">
                  {chartData_type && chartData_type.map((d) => {
                    return <li class="stats-data-1">
                      <i class="houzez-icon icon-sign-badge-circle mr-1"></i> <strong>{d.type_ratio.toFixed(2)}%</strong> <span>{d.name}</span>
                    </li>;
                  })}
                </ul>
              </div>
            </div>
          </div>

        </div>
        <div class="col-lg-4 col-md-12 col-sm-12">

          <div class="agent-profile-chart-wrap">
            <h2><span>{__('Property')}</span> {__('Status')}</h2>
            <div class="d-flex align-items-top">
              <div class="agent-profile-chart">
                <canvas id="stats-property-status" data-chart="[57.14285714285714,42.857142857142854]" width="89"
                  height="89" style="display: block; height: 100px; width: 100px;"></canvas>
              </div>
              <div class="agent-profile-data">
                <ul class="list-unstyled">
                  {chartData_status && chartData_status.map((d) => {
                    return <li class="stats-data-1">
                      <i class="houzez-icon icon-sign-badge-circle mr-1"></i> <strong>{d.status_ratio.toFixed(2)}%</strong> <span>{d.name}</span>
                    </li>;
                  })}

                </ul>
              </div>
            </div>
          </div>

        </div>

        <div class="col-lg-4 col-md-12 col-sm-12">

          <div class="agent-profile-chart-wrap">
            <h2><span>{__('Property')}</span> {__('Cities')}</h2>
            <div class="d-flex align-items-top">
              <div class="agent-profile-chart">
                <canvas id="stats-property-cities"
                  data-chart="[42.857142857142854,28.57142857142857,14.285714285714285,14.285714285714285]"
                  width="89" height="89" style="display: block; height: 100px; width: 100px;"></canvas>
              </div>
              <div class="agent-profile-data">
                <ul class="list-unstyled">

                  {chartData_city && chartData_city.map((d) => {
                    return <li class="stats-data-1">
                      <i class="houzez-icon icon-sign-badge-circle mr-1"></i> <strong>{d.city_ratio.toFixed(2)}%</strong> <span>{d.name}</span>
                    </li>;
                  })}
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
